import { constants } from 'day8-ui';

const { TYW_DESTINATION } = constants;

export const getUniqueEntriesFromArray = array => Array.from(new Set(array));

export const capitalizeFirstLetter = str => str.charAt(0).toUpperCase() + str.slice(1);


export const getVideo = destinationId => {
  switch (destinationId) {
  case TYW_DESTINATION.CROATIA_ORIGINAL:
    return 'https://player.vimeo.com/video/610715101';
  case TYW_DESTINATION.TAHITI:
    return 'https://player.vimeo.com/video/525065972';
  case TYW_DESTINATION.BVI:
    return 'https://www.youtube.com/embed/g6z_pdxRoPE';
  case TYW_DESTINATION.GREECE:
    return 'https://player.vimeo.com/video/595917514';
  case TYW_DESTINATION.SARDINIA:
    return 'https://player.vimeo.com/video/458590279';
  case TYW_DESTINATION.CROATIA_ULTRA:
    return 'https://player.vimeo.com/video/463045154';
  case TYW_DESTINATION.CROATIA_HIDEOUT:
    return 'https://www.youtube.com/embed/huHoVkMVLP0';
  case TYW_DESTINATION.MONTENEGRO:
    return 'https://player.vimeo.com/video/463054431';
  case TYW_DESTINATION.BAHAMAS:
    return 'https://player.vimeo.com/video/524915074';
  case TYW_DESTINATION.ST_LUCIA_MARTINIQUE:
    return 'https://player.vimeo.com/video/527263511';
  case TYW_DESTINATION.CROATIA_MBA_ROUTE:
    return 'https://player.vimeo.com/video/748749661';
  default:
    return null;
  }
};

